export const BADGE_QTY_LIMITS = {
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_14e86da0-5c81-405d-b0e9-55aedb70886c': 10,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_0309c1ef-8100-47f3-9d9c-6c5288ab4af5': 20,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_ccf9d412-32e7-4bcd-8cfc-70dcc0c7808b': 3,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_db102011-c408-4ab9-bb12-7c7fcefa81df': 2,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_c1050cb0-2a61-443e-a77a-5ba8bcd632f5': 5,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_8ed95d43-b373-499f-98f8-96ed3f8309ff': 3,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_09cdc30f-c5fa-474f-912b-259aac0a3baa': 3,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_992877a4-3a22-4733-8bae-740cab1924bf': 2,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_f51ed0fa-143d-45a2-8025-4fb48a8be99a': 2,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_890cdd9a-b7ba-4490-82c9-850ce8699045': 2,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_d5925465-246a-405a-934e-21c0c32a289e': 2,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_1ae78066-5e22-45b1-b973-85a9b58f8aa4': 1,
  'https://d2nic58uh63efu.cloudfront.net/badge/badge_2770398d-efd8-4fcd-b96f-a051d8e02804': 1
}

function pushBadgeUrl (urls, value) {
  if (!value) return
  if (typeof value === 'string') {
    urls.push(value)
    return
  }
  if (value.imageUrl) urls.push(value.imageUrl)
  else if (value.image_url) urls.push(value.image_url)
}

export function collectBadgeUrls (product) {
  const urls = []
  if (!product) return urls
  const badgeList = (Array.isArray(product.badgeList) && product.badgeList.length)
    ? product.badgeList
    : (Array.isArray(product.badge_list) && product.badge_list.length)
      ? product.badge_list
      : null
  if (badgeList) {
    badgeList.forEach((item) => pushBadgeUrl(urls, item))
    return urls
  }
  pushBadgeUrl(urls, product.badgeInfo || product.badge_info)
  return urls
}

function normalizeBadgeUrl (url) {
  return String(url).trim().split('?')[0].split('#')[0].replace(/\/+$/, '')
}

function getLimitByUrl (url) {
  const normalized = normalizeBadgeUrl(url)
  const keys = Object.keys(BADGE_QTY_LIMITS)
  for (let i = 0; i < keys.length; i++) {
    const allowed = normalizeBadgeUrl(keys[i])
    if (normalized === allowed) return BADGE_QTY_LIMITS[keys[i]]
    const extra = normalized.slice(allowed.length)
    if (normalized.indexOf(allowed) === 0 && /^[.][a-z0-9]+$/i.test(extra)) {
      return BADGE_QTY_LIMITS[keys[i]]
    }
  }
  return null
}

export function getBadgeQtyLimit (product) {
  const urls = collectBadgeUrls(product)
  let limit = null
  for (let i = 0; i < urls.length; i++) {
    const qty = getLimitByUrl(urls[i])
    if (qty === null) continue
    limit = limit === null ? qty : Math.min(limit, qty)
  }
  return limit
}

export function getOverBadgeQtyLimitItem (products) {
  if (!products || !products.length) return null
  for (let i = 0; i < products.length; i++) {
    const product = products[i]
    const limit = getBadgeQtyLimit(product)
    if (limit !== null && Number(product.order_qty) > limit) {
      return product
    }
  }
  return null
}

export function getBadgeQtyLimitAlert (product, qty) {
  const limit = getBadgeQtyLimit(product)
  if (limit === null || Number(qty) <= limit) return ''
  const name = product && (product.name || product.NAME)
  return name
    ? `${name}은(는) 최대 ${limit}개까지 주문할 수 있습니다.`
    : `이 상품은 최대 ${limit}개까지 주문할 수 있습니다.`
}



// WEBPACK FOOTER //
// ./src/js/badgeQtyLimit.js